import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const formValuesReducer = (state: IFormEventSlice, action: PayloadAction<any>) => {
    state.formValues = action.payload;
}

const setDataListSelectionReducer = (state: IFormEventSlice, action: PayloadAction<any>) => {
    state.listSelection = action.payload;
}

export interface IFormEventSlice {
    formValues: any;
    listSelection: Array<any>;
}

const initialState: IFormEventSlice = {
    formValues: {},
    listSelection: []
};

const formEventSlice = createSlice({
    name: 'form-event',
    initialState: initialState,
    reducers: {
        setFormValues: formValuesReducer,
        setDataListSelection: setDataListSelectionReducer
    },
});

export const formEventReducer = formEventSlice.reducer;
export const formEventActionProps = formEventSlice.actions;
export const { setFormValues, setDataListSelection } = formEventSlice.actions;